import React, { useState, useRef, forwardRef, useImperativeHandle } from "react";
import { useEffect } from "react";
import Select, {components} from "react-select";
import css from "./index.module.scss";
import dequals from "dequals";

const MenuList = ({ children, ...props }) => {
  return (
    <components.MenuList {...props}>
      {Array.isArray(children)
        ? children.slice(0, props.selectProps?.maxOptions) /*options */
        : children /*noOptionsLabel */
      }
    </components.MenuList>
  );
};
export default forwardRef(({
  onChange = () => {},
  maxOptions = 5,
  className = "",
  options = [{value: "testvalue", label: "testlabel"}],
  isMulti = false,
  noOptionsMessage = "No options found",
  placeholder = "",
  validators = [],
  defaultValue = null,
}, ref) => {
  const [value, setValue] = useState(defaultValue);
  const [message, setMessage] = useState("");
  const [validity, setValidity] = useState(null);

  async function validate(newValue){
    for (let validator of validators){
      if (await validator.test(newValue)){
        let result = false;
        if (validator.class === "valid"){
          result = true;
        } else if (validator.class === "invalid") {
          result = false;
        }

        setMessage(validator.message);
        setValidity(result);
        return result;
      }
    }
  }

  useImperativeHandle(ref, () => ({
    isValid() {
      return validate(value);
    },
    getValue() {
      return value;
    },
    setValue(newValue) {
      setValue(newValue);
    },
    setValid(newValidity) {
      setValidity(newValidity);
    },
    setMessage(newMessage) {
      setMessage(newMessage);
    },
  }));

  function handleChange(newValue){
    validate(newValue);
    setValue(newValue);
  }

  useEffect(() => {
    if (value !== null && (!defaultValue || !dequals(value, defaultValue))){
      onChange(value);
    }
  }, [value]);

  let thisClassName = `${css.selector} ${className}`;
  if (validity === true){
    thisClassName += ` ${css.valid}`;
  } else if (validity === false) {
    thisClassName += ` ${css.invalid}`;
  }

  return (
    <div className={thisClassName}>
      <Select
        ref={ref}
        defaultValue={defaultValue}
        value={value}
        onChange={handleChange}
        options={options}
        placeholder={placeholder}
        noOptionsMessage={() => noOptionsMessage}
        isMulti={isMulti}
        isSearchable={true}
        unstyled
        classNames={{
          control: (state) => state.isFocused ? `${css.control} ${css.focused}` : css.control,
          placeholder: () => css.placeholder,
          multiValue: () => css.multiValue,
          valueContainer: () => css.valueContainer,
          input: () => css.input,
          indicatorsContainer: () => css.indicatorsContainer,
          noOptionsMessage: () => css.noOptionsMessage,
          menu: () => css.menu,
          groupHeading: () => css.groupHeading,
          menuPortal: () => css.menuPortal,
          menuList: () => css.menuList,
          option: () => css.option,
        }}
        components={{ MenuList }}
        maxOptions={maxOptions}
      />
      <div className={css.message}>{message}</div>
    </div>
  );
});
